module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reveal-void"
  }, [_c('ModalReveal', [_c('button', {
    staticClass: "button danger",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Registration token")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Registration tokens"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.registrationToken),
      expression: "body.registrationToken"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "registrationToken", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.registrationTokens), function(token) {
    return _c('option', {
      domProps: {
        "value": token.id
      }
    }, [_vm._v("RT" + _vm._s(token.id) + " " + _vm._s(token.token))])
  }), 0)])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Type")]), (_vm.selected !== null) ? _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.selected.destination_type) + " " + _vm._s(_vm.selected.destination_id))]) : _vm._e(), _c('div', {
    staticClass: "label"
  }, [_vm._v("Additional")]), (_vm.selected !== null) ? _vm._l((_vm.selected.additional), function(additional) {
    return (_vm.selected !== null) ? _c('div', {
      staticClass: "field-value"
    }, [_vm._v(_vm._s(additional.class) + " " + _vm._s(additional.id))]) : _vm._e()
  }) : _vm._e()], 2)]), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.add
    },
    slot: "footer"
  }, [_vm._v("Add")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": function($event) {
        return _vm.$refs[_vm.componentId].close()
      }
    },
    slot: "footer"
  }, [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9bd5b616!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/ApplyRegistrationTokenReveal.vue
// module id = 2652
// module chunks = 1